import Orbit from "../../model/skillTree/orbit/Orbit";
import { GervaisSpriteNames } from "../../model/sprite/GervaisSpriteNames";
import Projection from "../../Projection";
import { Settings } from "../../Settings";
import SkillRenderer from "./SkillRenderer";

export default class OrbitSkillRenderer extends SkillRenderer {
    /**
     * @param {Orbit[]} orbitArray 
     * @param {GervaisAnimatedSpritesheet} spellFxSpritesheet 
     */
    constructor(orbitArray, spellFxSpritesheet) {
        super();

        /**
         * @constant
         * @type {Orbit[]}
         */
        this.orbitArray = orbitArray;
        /**
         * @constant
         * @type {GervaisAnimatedSpritesheet}
         */
        this.spellFxSpritesheet = spellFxSpritesheet;

        /**
         * The sprite animation used for the Laser skill.
         * @private
         * @type {SpriteAnimation}
         */
        this.skillAnimation = null;
        /**
         * @type {number}
         */
        this.skillStart = Date.now();

    }

    /**
     * @override
     * @param {CanvasRenderingContext2D} context 
     * @param {Projection} projection 
     */
    renderSkill(context, projection) {
        if (this.orbitArray.length === 0) {
            return;
        }

        // Save the line width.
        const safeLineWidth = context.lineWidth;
        context.lineWidth = 4;
        context.strokeStyle = '#AFA1';

        for (let i = 0; i < this.orbitArray.length; i++) {
            this.renderOrbit(context, projection, this.orbitArray[i]);
        }

        // Restore the line width
        context.lineWidth = safeLineWidth;
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} context 
     * @param {Projection} projection 
     * @param {Orbit} orbit
     */
    renderOrbit(context, projection, orbit) {
        if (!orbit.skillActive) {
            return;
        }

        const now = Date.now();
        if (now - this.skillStart > 100000) {
            this.skillStart = now; // bad things happen in the sprite animation manager if the start time is from 1970.
        }

        // Make sure the sprite is initialized.
        if (!this.skillAnimation) {
            this.skillAnimation = this.spellFxSpritesheet.getSpriteAnimation(GervaisSpriteNames.EFFECT_NAME_ORANGE_STAR);
        }

        const orbitPairs = orbit.orbitPairs;
        for (let i = 0; i < orbitPairs.length; i++) {
            const orbitPair = orbitPairs[i];

            //////////////////////////////////////
            // Draw a line betweent the character and the orb
            //////////////////////////////////////

            context.beginPath();

            projection.worldToScreen(orbitPair.center, this.screenCoordinate);
            context.moveTo(this.screenCoordinate.x, this.screenCoordinate.y);
            
            this.screenCoordinate.copy(orbitPair.endPoint);
            this.screenCoordinate.addXY(Settings.tile.halfSize, Settings.tile.halfSize);
            projection.worldToScreen(this.screenCoordinate, this.screenCoordinate);
            context.lineTo(this.screenCoordinate.x, this.screenCoordinate.y);

            context.stroke();

            ///////////////////////////////////////////
            // Draw a sprite at the end point
            ///////////////////////////////////////////

            this.screenCoordinate.copy(orbitPair.endPoint);

            projection.worldToScreen(this.screenCoordinate, this.screenCoordinate);

            const sprite = this.skillAnimation.getSpriteAsOf(Date.now(), this.skillStart);

            this.renderSprite(context, projection, sprite, this.screenCoordinate);
        }

    }

}